import { render } from "./nameComponent.vue?vue&type=template&id=5f8af1a2&scoped=true"
import script from "./nameComponent.vue?vue&type=script&lang=js"
export * from "./nameComponent.vue?vue&type=script&lang=js"

import "./nameComponent.vue?vue&type=style&index=0&id=5f8af1a2&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8af1a2"]])

export default __exports__